export default "__VITE_ASSET__e73532b2__"